module.exports = __webpack_public_path__ + "static/media/logo.dd65719e.svg";